// vokshus-fulfillment-packing.js
// Väver in kundens valda mønster PÅ ENGELSKA i den dolda _PackingList-propertyn, så
// SpeedFulfill (som läser _PackingList, inte de separata _Mønster-fälten) får veta
// vilket mønster som ska packas. Kundsynlig text är oförändrad (_PackingList är dold via `_`).
//
// Rotorsak/design: docs/superpowers/specs/2026-07-24-speedfulfill-pattern-in-packing-design.md
//
// Vanilla IIFE, deferred, feature-detekterad. Ett fel får ALDRIG blockera köp (try/catch).
(function () {
  'use strict';

  // _Mønster-värde → kanonisk engelska. Okänt → oförändrat.
  // Köprutorna skickar variantens VISADE titel, och Translate & Adapt översätter den
  // per marknad. Därför måste HVERT publisert språk ligga her, ikke bare bokmål.
  //
  // 🔴 SJU SPRÅK ER PUBLISERT (shopLocales, verifisert 2026-08-21): nb (primær),
  // en, sv, da, nl, de, fr. Ordboken sto stille fra 2026-08-09 mens de + nl kom
  // 16/8, da 18/8 og fr 20/8. Følgen var taus: toEn() returnerer ukjente ord
  // uforandret, så SpeedFulfill fikk «Grønt køkken» (ordre #1357) eller ingenting
  // i det hele tatt (#1353, #1359). Legger du til et språk til, legg det inn HER,
  // i PATTERN_FIELD nedenfor, i de to kopiene, og i testen.
  // Vakt: scripts/check-pattern-dictionary.py leser oversettelses-DB-en live og
  // feller enhver deploy der et publisert språk har et mønsternavn som mangler her.
  //
  // 🔴 «citron» PEKER PÅ LEMON, IKKE CITRUS. Det sto som dansk alias for Sitrus
  // fram til 2026-08-09, da mønsteret Sitron kom til. Sitron heter «Citron» på
  // BÅDE svensk, dansk og fransk, og ingen av de sju språkene kaller Sitrus
  // «Citron» (da/en/nl = Citrus, de = Zitrus, fr = Agrumes, sv = Citrus). Snur du
  // dette, pakker SpeedFulfill sitrusmønsteret på hver eneste Sitron-ordre.
  var MAP = {
    'sitrus': 'Citrus', 'citrus': 'Citrus',
    'honning': 'Honey', 'honey': 'Honey', 'honung': 'Honey',
    'jordbær': 'Strawberry', 'jordbaer': 'Strawberry', 'strawberry': 'Strawberry',
    'jordgubbe': 'Strawberry', 'jordgubbar': 'Strawberry',
    'granateple': 'Pomegranate', 'pomegranate': 'Pomegranate',
    'granatäpple': 'Pomegranate', 'granatapple': 'Pomegranate', 'granatæble': 'Pomegranate',
    // Seks nye mønstre 2026-08-09. Rekkefølgen per rad er nb, en, sv, deretter
    // ascii-varianter av de nordiske tegnene, fordi variant-titler har blitt
    // transkribert uten ø og ö før.
    'bikube': 'Beehive', 'beehive': 'Beehive', 'bikupa': 'Beehive',
    'zero waste': 'Zero Waste', 'zerowaste': 'Zero Waste',
    'jungel': 'Jungle', 'jungle': 'Jungle', 'djungel': 'Jungle',
    'sitrusskiver': 'Citrus Slices', 'citrus slices': 'Citrus Slices',
    'citrusskivor': 'Citrus Slices',
    'sitron': 'Lemon', 'lemon': 'Lemon', 'citron': 'Lemon',
    'grønt kjøkken': 'Green Kitchen', 'gront kjokken': 'Green Kitchen',
    'green kitchen': 'Green Kitchen',
    'grönt kök': 'Green Kitchen', 'gront kok': 'Green Kitchen',
    // DANSK (/da-dk), tillagt 2026-08-21. Honning, Jordbær, Bikube og Zero Waste
    // har INGEN dansk rad i oversettelses-DB-en og faller tilbake på bokmål — de
    // står allerede over. «Grønt køkken» hadde allerede lekket til SpeedFulfill
    // uoversatt på ordre #1357 (2026-08-20) da denne raden ble lagt inn.
    'granataeble': 'Pomegranate',
    'citrusskiver': 'Citrus Slices',
    'grønt køkken': 'Green Kitchen', 'gront kokken': 'Green Kitchen',
    // NEDERLANDSK (/nl-eu), tillagt 2026-08-21. Citrus, Zero Waste og Jungle er
    // identiske med engelsk. Ordre #1359 gikk uten mønster fordi nedtrekket viste
    // «Honing».
    'honing': 'Honey',
    'aardbei': 'Strawberry',
    'granaatappel': 'Pomegranate',
    'bijenkorf': 'Beehive',
    'citrusschijfjes': 'Citrus Slices',
    'citroen': 'Lemon',
    'groene keuken': 'Green Kitchen',
    // TYSK (/de-eu og /de-intl), tillagt 2026-08-21. Zero Waste er uoversatt og
    // står allerede over. Både u- og ue-transkripsjonen av ü ligger med: en miss
    // her er taus.
    'zitrus': 'Citrus',
    'honig': 'Honey',
    'erdbeere': 'Strawberry',
    'granatapfel': 'Pomegranate',
    'bienenstock': 'Beehive',
    'dschungel': 'Jungle',
    'zitrusscheiben': 'Citrus Slices',
    'zitrone': 'Lemon',
    'grüne küche': 'Green Kitchen', 'grune kuche': 'Green Kitchen',
    'gruene kueche': 'Green Kitchen',
    // FRANSK (/fr-eu), tillagt 2026-08-21. Citron er Lemon på fransk også og står
    // allerede over. 🔴 Sitrusskiver har TO franske navn i drift: oversettelses-DB-en
    // sier «Rondelles d'agrumes» (variant-tittelen kunden faktisk sender), mens
    // locales/fr.json sier «Tranches d'agrumes» (etiketten i mønster-listene).
    // BEGGE må stå her, i rak og typografisk apostrof, til den ene er borte.
    'agrumes': 'Citrus',
    'miel': 'Honey',
    'fraise': 'Strawberry',
    'grenade': 'Pomegranate',
    'ruche': 'Beehive',
    "rondelles d'agrumes": 'Citrus Slices', 'rondelles d’agrumes': 'Citrus Slices',
    "tranches d'agrumes": 'Citrus Slices', 'tranches d’agrumes': 'Citrus Slices',
    'cuisine verte': 'Green Kitchen',
    // Avocado replacement and new roll patterns, all seven customer languages.
    "avokado": "Avocado",
    "avocado": "Avocado",
    "avocat": "Avocado",
    "store blader": "Large leaves",
    "large leaves": "Large leaves",
    "stora blad": "Large leaves",
    "store blade": "Large leaves",
    "große blätter": "Large leaves",
    "grandes feuilles": "Large leaves",
    "grote bladeren": "Large leaves",
    "grønn hverdag": "Green living",
    "green living": "Green living",
    "grön vardag": "Green living",
    "grøn hverdag": "Green living",
    "grüner alltag": "Green living",
    "quotidien vert": "Green living",
    "groen leven": "Green living",
    "vannmelon": "Watermelon",
    "watermelon": "Watermelon",
    "vattenmelon": "Watermelon",
    "vandmelon": "Watermelon",
    "wassermelone": "Watermelon",
    "pastèque": "Watermelon",
    "watermeloen": "Watermelon",
    "sitrusfrukt": "Watermelon",
    "citrus fruit": "Watermelon",
    "citrusfrukt": "Watermelon",
    "citrusfrugt": "Watermelon",
    "citrusvruchten": "Watermelon",
    "zitrusfrüchte": "Watermelon",
    "mélange d'agrumes": "Watermelon",
    // Bivoksposer (Inkorgen 105, 26/10): fem mønster, sju språk, samma namn som Translate & Adapt.
    "brød og croissant": "Bread and croissant",
    "bread and croissant": "Bread and croissant",
    "bröd och croissant": "Bread and croissant",
    "brood en croissant": "Bread and croissant",
    "brot und croissant": "Bread and croissant",
    "pain et croissant": "Bread and croissant",
    "brød og kjevle": "Bread and rolling pin",
    "bread and rolling pin": "Bread and rolling pin",
    "bröd och kavel": "Bread and rolling pin",
    "brød og kagerulle": "Bread and rolling pin",
    "brood en deegroller": "Bread and rolling pin",
    "brot und nudelholz": "Bread and rolling pin",
    "pain et rouleau": "Bread and rolling pin",
    "kirsebær": "Cherry",
    "cherry": "Cherry",
    "körsbär": "Cherry",
    "kers": "Cherry",
    "kirsche": "Cherry",
    "cerise": "Cherry",
    "oliven": "Olive",
    "olive": "Olive",
    "oliver": "Olive",
    "olijf": "Olive",
    "regnbue": "Rainbow",
    "rainbow": "Rainbow",
    "regnbåge": "Rainbow",
    "regenboog": "Rainbow",
    "regenbogen": "Rainbow",
    "arc-en-ciel": "Rainbow",
    "cytrusy": "Citrus",
    "owoce cytrusowe": "Watermelon",
    "citrusové ovoce": "Watermelon",
    "miód": "Honey",
    "med": "Honey",
    "truskawki": "Strawberry",
    "jahody": "Strawberry",
    "granat": "Pomegranate",
    "granátové jablko": "Pomegranate",
    "včelín": "Beehive",
    "dżungla": "Jungle",
    "džungle": "Jungle",
    "plaster miodu": "Beehive",
    "plastry cytrusów": "Citrus Slices",
    "plátky citrusů": "Citrus Slices",
    "cytryna": "Lemon",
    "zielona kuchnia": "Green Kitchen",
    "zelená kuchyň": "Green Kitchen",
    "awokado": "Avocado",
    "avokádo": "Avocado",
    "duże liście": "Large leaves",
    "velké listy": "Large leaves",
    "zielona codzienność": "Green living",
    "zelený všední den": "Green living",
    "chleb i rogalik": "Bread and croissant",
    "chléb a croissant": "Bread and croissant",
    "chleb i wałek": "Bread and rolling pin",
    "chléb a váleček": "Bread and rolling pin",
    "wiśnie": "Cherry",
    "třešně": "Cherry",
    "oliwki": "Olive",
    "olivy": "Olive",
    "tęcza": "Rainbow",
    "duha": "Rainbow"
  };

  function toEn(v) {
    if (!v) return '';
    var t = String(v).trim();
    return MAP[t.toLowerCase()] || t;
  }

  // Slår upp et mønsternavn STRIKT: treff eller tom streng, aldri råteksten.
  // Nedtrekket i sections/vokshus-catalog-product.liquid:457 henger på en etikett
  // når varianten er utsolgt — «Sitrus, Utsolgt», «Citrus, Slutsåld»,
  // «Zitrus, Ausverkauft» — og den varianten kan stå `selected`. Oppslaget er
  // eksakt, så påhenget hadde gjort mønsteret usynlig. Prøv derfor også teksten
  // før siste komma. Ingen mønsternavn inneholder komma, så det er trygt.
  function lookupPattern(raw) {
    var t = String(raw || '').trim();
    if (!t) return '';
    var hit = MAP[t.toLowerCase()];
    if (hit) return hit;
    var i = t.lastIndexOf(',');
    if (i > 0) {
      hit = MAP[t.slice(0, i).trim().toLowerCase()];
      if (hit) return hit;
    }
    return '';
  }

  // Mønster-fältets namn finns i två familjer, och ALLA måste hittas, annars tappar
  // _PackingList mønstret och SpeedFulfill får gissa:
  //   dolt (internt, aldrig kundsynligt): _Pattern sedan 2026-08-05, _Mønster i äldre
  //     ordrar och öppna kurvar. Båda måste fortsätta matcha.
  //   synligt (kundsynligt, följer hennes språk): Mønster på /, Pattern på /en,
  //     Mönster på /sv, Muster på /de-eu, Patroon på /nl-eu, Motif på /fr-eu.
  //     🔴 VARJE PUBLICERAT SPRÅK MÅSTE STÅ HÄR. Fältnamnet sätts av grenarna i
  //     de fem GRUPP A-filerna och följer kundens språk. Saknas etiketten hittas
  //     fältet aldrig, och _PackingList går till SpeedFulfill UTAN mønster, tyst.
  //     Muster och Patroon saknades från 16/8 till 20/8: varje tysk och
  //     nederländsk bivokspapir-order packades utan mønsterval under de dygnen.
  //     Nytt språk läggs till HÄR, i num() nedan, och i testet.
  var PATTERN_FIELD = /properties\[\s*_?(?:Mønster|Mönster|Monster|Pattern|Muster|Patroon|Motif|Wzór|Vzor)\b/i;

  function isPatternField(name) {
    return PATTERN_FIELD.test(name || '');
  }

  // Ordningsnummer ur "properties[Mønster 2]" → 2 (onumrerat → 0).
  function num(name) {
    var m = (name || '').match(/_?(?:Mønster|Mönster|Monster|Pattern|Muster|Patroon|Motif|Wzór|Vzor)\s*(\d+)/i);
    return m ? parseInt(m[1], 10) : 0;
  }

  // fields = [{name, value}, …] → "Pattern 1: Citrus, Pattern 2: Honey"
  // (eller "Pattern: Citrus" vid ett enda fält). Ren funktion (testbar).
  function patternSuffix(fields) {
    if (!fields || !fields.length) return '';
    var sorted = fields.slice().sort(function (a, b) { return num(a.name) - num(b.name); });
    var multi = sorted.length > 1;
    return sorted.map(function (f, i) {
      var en = toEn(f.value);
      if (!en) return null;
      return (multi ? 'Pattern ' + (num(f.name) || i + 1) : 'Pattern') + ': ' + en;
    }).filter(Boolean).join(', ');
  }

  // Fristående bivokspapir: mønstret ÄR varianttiteln, så bas-strängen bär en
  // pekare i stället för värdet. Måste alltid ersättas — SpeedFulfill ska aldrig
  // se instruktionen "pattern = variant title", bara det valda mønstret.
  var VARIANT_MARKER = /;\s*pattern\s*=\s*variant title/i;

  // Vald option i wrap-dropdownen (name="id") → "Pattern: Citrus". Ren funktion.
  // STRIKT: bara KÄNDA mønsternamn ger ett suffix. Andra varianter väljs också med
  // name="id" (Basis-sett, Pluss-sett, …) och får aldrig bli "Pattern: Basis-sett".
  function variantSuffix(form) {
    var sel = form && form.querySelector ? form.querySelector('select[name="id"]') : null;
    if (!sel || !sel.options || sel.selectedIndex < 0) return '';
    var opt = sel.options[sel.selectedIndex];
    var raw = String((opt && (opt.textContent || opt.value)) || '').trim();
    var en = lookupPattern(raw);
    return en ? 'Pattern: ' + en : '';
  }

  // 🔴 ORDER #1242 (2026-08-03, packad och skickad innan felet upptäcktes):
  // packinstruktionen bar SEX motstridiga mønsterblock, där bara det sista stämde med
  // kundens val. Orsak: basen läses ur inputens LEVANDE .value första gången JS kör, och
  // webbläsare återställer formulärvärden vid reload och bakåtnavigering. En redan hopsatt
  // sträng blev då "bas", och paren-grenen nedan infogar före första ")" utan att märka att
  // det redan står ett block där. compose() MÅSTE därför tåla sitt eget resultat som indata.
  // Kravet är låst i scripts/test-fulfillment-packing.js.
  var COMPOSED_BLOCK = /\s*—\s*Pattern(?:\s*\d+)?\s*:[^—)]*/gi;

  function stripComposed(base) {
    return String(base || '').replace(COMPOSED_BLOCK, '');
  }

  // Foga in mønstret i bas-strängen. 1) ersätt pekar-klausulen om den finns,
  // 2) annars inuti "wrap sets (…)", 3) annars före "; e-book", 4) annars appenda. Ren funktion.
  function compose(base, suffix) {
    if (!suffix) return base;
    // Alltid tillbaka till en ren bas först, annars staplas block (se #1242 ovan).
    base = stripComposed(base);
    // Två pekar-klausuler finns i temat: den äldre «; patterns in _Mønster …» och
    // 3-packens «; patterns = customer selected» (sections/vokshus-wrap-3pack.liquid).
    // Båda ska BYTAS mot de faktiska valen — SpeedFulfill får aldrig se instruktionen.
    var pointer = /;\s*patterns?\s*(?:in _Mønster|=\s*customer selected)[^)]*/i;
    if (pointer.test(base)) return base.replace(pointer, ' — ' + suffix);
    if (VARIANT_MARKER.test(base)) return base.replace(VARIANT_MARKER, ' — ' + suffix);
    var paren = /(wrap sets?\s*\([^)]*?)(\))/i;
    if (paren.test(base)) return base.replace(paren, '$1 — ' + suffix + '$2');
    var idx = base.indexOf('; e-book');
    if (idx !== -1) return base.slice(0, idx) + ' — ' + suffix + base.slice(idx);
    return base + ' — ' + suffix;
  }

  // Radio/checkbox räknas BARA när de är valda. 3-packens köpruta använder radios som
  // heter properties[Mønster 1..3] (native POST bär då valen utan JS), och utan det här
  // filtret skulle alla fyra mønstren per rad räknas som valda samtidigt.
  // <select> och dolda fält har ingen .checked och passerar oförändrat.
  function isPicked(el) {
    var t = (el.type || '').toLowerCase();
    if (t === 'radio' || t === 'checkbox') return !!el.checked;
    return true;
  }

  function fieldsFromForm(form) {
    var els = form.querySelectorAll('[name^="properties["]');
    return Array.prototype.filter.call(els, function (el) {
      return isPatternField(el.name) && isPicked(el);
    }).map(function (el) {
      return { name: el.name, value: el.value };
    });
  }

  function updatePackingList(form) {
    try {
      var packing = form.querySelector('[name="properties[_PackingList]"]');
      if (!packing) return;
      // Kombopaket bär _Mønster-fält; fristående wrap har bara varianten vald.
      var suffix = patternSuffix(fieldsFromForm(form)) || variantSuffix(form);
      if (!suffix) return;
      // Spara originalsträngen en gång så omval alltid räknas från basen (ingen ackumulering).
      var base = packing.getAttribute('data-vk-packing-base');
      if (base === null) {
        base = packing.value;
        packing.setAttribute('data-vk-packing-base', base);
      }
      packing.value = compose(base, suffix);
    } catch (e) { /* aldrig blockera köp */ }
  }

  function wire() {
    var forms = document.querySelectorAll('form');
    Array.prototype.forEach.call(forms, function (form) {
      // Native pack choices are composed and checked by Liquid before checkout.
      if (form.querySelector('[name="properties[_VokshusNativePacking]"]')) return;
      var packing = form.querySelector('[name="properties[_PackingList]"]');
      if (!packing) return;
      // Antingen ett kombopaket (_Mønster-fält) eller en fristående wrap
      // (varianttiteln = mønstret). Andra formulär rör vi inte.
      var hasMonster = fieldsFromForm(form).length > 0;
      // Mønstret kan också bo i varianten (fristående wrap + Kjøkken-pakken, som
      // har en variant per mønster). variantSuffix är strikt, så andra
      // variant-dropdowns (Basis-sett, …) ger tomt och rör inte _PackingList.
      var hasPatternVariant = !!variantSuffix(form);
      if (!hasMonster && !hasPatternVariant) return;
      form.addEventListener('change', function (e) {
        var n = (e.target && e.target.name) || '';
        if (isPatternField(n) || n === 'id') updatePackingList(form);
      });
      // Capture så värdet är uppdaterat innan AJAX-ATC (vokshus-bundle.js) bygger FormData.
      form.addEventListener('submit', function () { updatePackingList(form); }, true);
      updatePackingList(form); // init: default-valen
    });
  }

  if (typeof document !== 'undefined' && document.querySelectorAll) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', wire);
    } else {
      wire();
    }
  }

  // Node-export ENDAST för test (browser: `module` odefinierad → no-op).
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      toEn: toEn, num: num, patternSuffix: patternSuffix, lookupPattern: lookupPattern,
      compose: compose, variantSuffix: variantSuffix, isPatternField: isPatternField,
      MAP: MAP
    };
  }
})();
